import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './Button.styles.less';
export default function Button({ className = null, component: Element = 'button', type = 'button', theme = 'primary', elementRef = null, children = null, ...others }) {
    const [appTheme] = useTheme();
    return (_jsx(Element, { "data-button": true, className: cx(classes.button, classes[theme], classes[appTheme], className), type: type, ref: elementRef, ...others, children: children }));
}
